import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CredentialsService } from '../../credentials.service';


export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const credentialsService = inject(CredentialsService);

  if (credentialsService.isAuthenticated()) {
    return true;
  }

  router.navigate([''], {
    queryParams: { redirect: state.url },
    replaceUrl: true,
  });

  return false;
};
